import React, {
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

export const useDelayedState = <T>(
  initialValue: T,
  delay = 200
): [T, React.Dispatch<SetStateAction<T>>, (value: T) => void] => {
  const [value, setValue] = useState<T>(initialValue);
  const timeout = useRef(0);

  const setDelayValue = useCallback(
    (value: T) => {
      timeout.current = window.setTimeout(() => {
        setValue(value);
      }, delay);
    },
    [delay]
  );

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current);
    };
  }, []);

  return [value, setValue, setDelayValue];
};
